var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.attribute.value
    ? _c(
        "div",
        [
          _vm.definition.type === _vm.CardAttributeDefinitionType.String
            ? [
                _c("i", { staticClass: "fa fa-asterisk" }),
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.definition.name) +
                    " " +
                    _vm._s(_vm.attribute.value) +
                    "\n  "
                )
              ]
            : _vm.definition.type === _vm.CardAttributeDefinitionType.Integer
            ? [
                _c("i", { staticClass: "fa fa-asterisk" }),
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.definition.name) +
                    " " +
                    _vm._s(_vm.attribute.value) +
                    "\n  "
                )
              ]
            : _vm.definition.type === _vm.CardAttributeDefinitionType.Datetime
            ? [
                _c("i", { staticClass: "fa fa-asterisk" }),
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.definition.name) +
                    " " +
                    _vm._s(_vm.formatDateTime(_vm.attribute.value)) +
                    "\n  "
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.definition.type === _vm.CardAttributeDefinitionType.Link
            ? [
                _c("i", { staticClass: "fa fa-asterisk" }),
                _vm._v("\n    " + _vm._s(_vm.definition.name) + " "),
                _c(
                  "a",
                  { attrs: { href: _vm.attribute.value, target: "_blank" } },
                  [_vm._v(_vm._s(_vm.attribute.value))]
                )
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }